export default function ReviewIcon({ size = 20, ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            <rect x="3.5" y="3.5" width="17" height="17" rx="4" />
            <path d="m8 12.5 2.8 2.8L16.5 9" />
        </svg>
    );
}
